import { FC } from 'react';

export type InputErrorProps = {
  /**
   * Content of the error
   */
  text: string;
};

const BASE_INPUTERROR_CLASSES = 'text-red-200 text-2xs mt-1 font-medium block';

export const InputError: FC<InputErrorProps> = ({
  text = 'Error',
}: InputErrorProps) => {
  return <span className={BASE_INPUTERROR_CLASSES}>{text}</span>;
};
